import { render, staticRenderFns } from "./VideoV2Loop.vue?vue&type=template&id=1f1000a4&scoped=true"
import script from "./VideoV2Loop.vue?vue&type=script&lang=js"
export * from "./VideoV2Loop.vue?vue&type=script&lang=js"
import style0 from "./VideoV2Loop.vue?vue&type=style&index=0&id=1f1000a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1000a4",
  null
  
)

export default component.exports